import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { OMSDropdown } from "../../../../app/common/common-components/OMSDropdown";
import { useStore } from "../../../../app/stores/store";
import TaskModel from "../../common/TaskModel";
import ConfirmationModalPopup from "../../../../app/common/common-components/ModalPopups/ConfirmationModalPopup";
import apiAgent from "../../../../app/api/apiAgent";
import { toast } from "react-toastify";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

const DealTaskStepView = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({
    getData() {
      var entity = taskData;
      return entity;
    },
  }));

  const taskModelRef = useRef();
  const [tasksStageDD, setTasksStageDD] = useState([
    {
      text: "",
      value: "",
    },
  ]);
  const [assignedRolesDD, setAssignedRolesDD] = useState([
    {
      text: "",
      value: "",
    },
  ]);
  const [taskData, setTaskData] = useState([]);
  const [taskExpected, setTaskExpected] = useState();
  const [taskExpectedIDX, setTaskExpectedIDX] = useState(null);
  const [isTaskEdit, setIsTaskEdit] = useState(null);
  const [newTaskIDIndex, setNewTaskIDIndex] = useState(0);
  const [confirmationModalProps, setConfirmationModalProps] = useState({
    showModal: false,
    isConfirmed: (result) => {},
    title: "",
    body: "",
  });

  const {
    userStore: { userSession },
  } = useStore();

  // Model Open Handles
  const onStageExpectedModelOpen = (curVal, curIDX) => {
    setTaskExpectedIDX(curIDX);
    setTaskExpected(`${curVal.stageExpected.split("-")[2]}-${curVal.stageExpected.split("-")[1]}-${curVal.stageExpected.split("-")[0]}`);
    window.$("#task_expected_model").modal("show");
  };
  const onNewTaskModelOpen = () => {
    setNewTaskIDIndex(newTaskIDIndex + 1);
    setIsTaskEdit(false);
    taskModelRef.current.onModelClick(tasksStageDD[0].value, {
      taskId: "NAP_" + newTaskIDIndex,
      taskName: "",
      taskDueDate: "",
      status: 1,
      description: "",
      comment: "",
      comments: [],
      assignedRoles: [],
      dealId: props.dealID,
      dealName: props.dealName,
      statusUpdatedOn: "",
      stageExpected: "",
      taskCompletedDate: "",
      status: 1,
      description: "",
      taskDueDate: "",
      stageDD: tasksStageDD,
      taskIndex: 0,
    });
  };
  const onTaskITemClick = (stage, curTask) => {
    setIsTaskEdit(true);
    taskModelRef.current.onModelClick(stage, curTask);
  };

  // Save Handles
  const onTaskSave = (task, curStage) => {
    const allTaskData = [...taskData];
    const newTaskData = allTaskData.map((stage) => {
      if (stage.stageName === curStage) {
        stage.stageTasks.push(task);
      }
      return stage;
    });
    setTaskData(newTaskData);
    props.onDataChange(newTaskData);
  };

  // Edit Handles
  const onStageExpectedEdit = () => {
    const newData = [...taskData];
    if (taskExpectedIDX !== null) {
      newData[taskExpectedIDX].stageExpected = `${taskExpected.split("-")[2]}-${taskExpected.split("-")[1]}-${taskExpected.split("-")[0]}`;
      setTaskData(newData);
    }
    window.$("#task_expected_model").modal("hide");
  };
  const onTaskEditSave = (isTaskDelete, task, curStage, prevStage) => {
    if (isTaskDelete) {
      var md = {
        showModal: true,
        isConfirmed: (result) => {
          deleteTaskCallback(result, curStage, task.taskId);
        },
        title: "Delete Task",
        body: "Are you sure you want to delete this Task? This cannot be undone.",
      };
      setConfirmationModalProps(md);
    } else {
      const newData = [...taskData];
      const prevStageIndex = newData.findIndex((stage) => stage.stageName === prevStage);
      const curStageIndex = newData.findIndex((stage) => stage.stageName === curStage);

      if (curStageIndex != -1) {
        if (prevStageIndex != -1) {
          const prevTaskIndex = newData[prevStageIndex].stageTasks.findIndex((ele) => ele.taskId === task.taskId);
          if (prevTaskIndex != -1) {
            newData[prevStageIndex].stageTasks.splice(prevTaskIndex, 1);
          }
        }

        newData[curStageIndex].stageTasks = [...newData[curStageIndex].stageTasks, task];
        setTaskData(newData);
        props.onDataChange(newData);
      }
    }
  };

  // Task Status DD Handle
  const handleTaskStatusDD = (stage, taskId, status) => {
    //console.log(stage);
    //console.log(taskId);
    //console.log(status);
    let stageIdx = null;
    let curStage = taskData.find((curEle, i) => {
      stageIdx = i;
      return stage === curEle.stageName;
    });

    let restStages = taskData.filter((curStage, i) => {
      return stage !== curStage.stageName;
    });

    let curTask = curStage.stageTasks.find((curElem, i) => {
      return curElem.taskId === taskId;
    });

    if (status == 5) {
      var md = {
        showModal: true,
        isConfirmed: (result) => {
          deleteTaskCallback(result, stage, taskId);
        },
        title: "Delete Task",
        body: "Are you sure you want to delete this Task? This cannot be undone.",
      };
      setConfirmationModalProps(md);
    } else {
      curTask.status = parseInt(status);
      const curDateAndTime = displayDateAndTime();
      let commentSmg = "";
      let commentSmgValue = getTaskMIlestoneDD().find((curStatus) => {
        return curStatus.value == parseInt(status);
      });
      if (commentSmgValue?.value == 1) {
        commentSmg = "marked this task as Not Started";
      } else if (commentSmgValue?.value == 2) {
        commentSmg = "marked this task as In Progress";
      } else if (commentSmgValue?.value == 3) {
        commentSmg = "marked this task as Issue";
      } else if (commentSmgValue?.value == 4) {
        commentSmg = "marked this task as Completed";
      } else if (commentSmgValue?.value == 5) {
        commentSmg = "marked this task as Deleted";
      }
      let eleComment = {
        commentID: "",
        userID: props?.userID,
        comment: `${userSession?.displayName} ${commentSmg}`,
        isStatusChanged: true,
        createdOn: curDateAndTime,
        updatedOn: "",
        displayName: userSession?.displayName,
        fileID: "",
        fileName: "",
        documentName: "",
        url: "",
        size: 0,
        displaySize: "",
      };
      curTask.comments.push(eleComment);
      restStages.splice(stageIdx, 0, curStage);
      setTaskData(restStages);
      props.onDataChange(restStages);
    }

    let model = {
      taskId: taskId,
      taskName: curTask.taskName,
      status: status,
      statusUpdatedOn: curTask.statusUpdatedOn,
      stageExpected: curTask.stageExpected,
      taskCompletedDate: curTask.taskCompletedDate,
      taskDueDate: curTask.taskDueDate,
      assignedRoles: curTask.assignedRoles,
      comments: curTask.comments,
      description: curTask.description,
      dealId: props.dealID,
      stageName: stage,
      stageDD: curTask.stageDD,
      taskIndex: curTask.taskIndex,
    };

    apiAgent.Deal.saveTaskAjax(model).then((res) => {
      //console.log(res);
      toast.info("Task Status Updated");
    });
  };

  // Task Delete Handle
  const deleteTaskCallback = (result, stage, taskId, status) => {
    setConfirmationModalProps({
      showModal: false,
      isConfirmed: (result) => {},
      title: "",
      body: "",
    });
    if (result) {
      const newData = [...taskData];
      const stageIndex = newData.findIndex((ele) => ele.stageName === stage);
      if (stageIndex != -1) {
        const taskIndex = newData[stageIndex].stageTasks.findIndex((ele) => ele.taskId === taskId);
        if (taskIndex != -1) {
          newData[stageIndex].stageTasks.splice(taskIndex, 1);
          setTaskData(newData);
          props.onDataChange(newData);
        }
      }
      taskModelRef.current.onModelHide();
    } else {
    }
  };

  // Other Functions
  const onTaskArrowUpClick = (stageName, task, taskIDX) => {
    let newTaskData = [...taskData];
    let stageIdx = newTaskData.findIndex((curStage, i) => {
      return curStage.stageName == stageName;
    });
    newTaskData[stageIdx].stageTasks.splice(taskIDX, 1);
    newTaskData[stageIdx].stageTasks.splice(taskIDX - 1, 0, task);
    setTaskData(newTaskData);
  };
  const onTaskArrowDownClick = (stageName, task, taskIDX) => {
    let newTaskData = [...taskData];
    let stageIdx = newTaskData.findIndex((curStage, i) => {
      return curStage.stageName == stageName;
    });
    newTaskData[stageIdx].stageTasks.splice(taskIDX, 1);
    newTaskData[stageIdx].stageTasks.splice(taskIDX + 1, 0, task);
    setTaskData(newTaskData);
  };
  const dateFormater = (inputDateStr) => {
    const parts = inputDateStr.split("-");
    const day = parts[0];
    const month = parts[1];
    const year = parts[2];
    const inputDate = new Date(year, month - 1, day);
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const dayOfMonth = inputDate.getDate();
    const abbreviatedMonth = monthNames[inputDate.getMonth()];
    const fullYear = inputDate.getFullYear();
    const formattedDateStr = `${dayOfMonth} ${abbreviatedMonth} ${fullYear}`;
    return formattedDateStr;
  };
  const dateFormater2 = (inputDateStr) => {
    const parts = inputDateStr.split("-");
    const year = parts[0];
    const month = parts[1];
    const day = parts[2];
    const inputDate = new Date(year, month - 1, day);
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const dayOfMonth = inputDate.getDate();
    const abbreviatedMonth = monthNames[inputDate.getMonth()];
    const fullYear = inputDate.getFullYear();
    const formattedDateStr = `${dayOfMonth} ${abbreviatedMonth} ${fullYear}`;
    return formattedDateStr;
  };
  const displayDate = () => {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const now = new Date();
    const day = now.getDate();
    const month = months[now.getMonth()];
    const year = now.getFullYear();
    const formattedDateAndTime = `${day} ${month} ${year}`;
    return formattedDateAndTime;
  };
  const displayDateAndTime = () => {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const now = new Date();

    const day = now.getDate();
    const month = months[now.getMonth()];
    const year = now.getFullYear();

    let hours = now.getHours();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    const minutes = String(now.getMinutes()).padStart(2, "0");

    const formattedDateAndTime = `${day} ${month} ${year} at ${hours}:${minutes} ${ampm}`;

    return formattedDateAndTime;
  };
  const getTaskMIlestoneDD = (value) => {
    return [
      {
        text: "Not Started",
        value: 1,
      },
      {
        text: value == 2 ? "In Progress" : "Mark As In Progress",
        value: 2,
      },
      {
        text: value == 3 ? "Issue" : "Mark As Issue",
        value: 3,
      },
      {
        text: value == 4 ? "Completed" : "Mark As Completed",
        value: 4,
      },
      {
        text: "Delete Task",
        value: 5,
      },
    ];
  };

  useEffect(() => {
    setTaskData(props.data);
    if (props.data) {
      const stages = props.data?.map((curEle) => {
        return { value: curEle.stageName, text: curEle.stageName };
      });
      setTasksStageDD(stages);
    }
    if (props.assignedRolesDD != 0) {
      const assignedRoles = props.assignedRolesDD?.map((curElem) => {
        return { text: curElem, value: curElem };
      });
      setAssignedRolesDD(assignedRoles);
    }
  }, [props]);
  const onDragEnd = (result) => {
    const { destination, source, draggableId } = result;

    if (!destination) {
      return;
    }

    if (destination.droppableId === source.droppableId && destination.index === source.index) {
      return;
    }

    if (destination.droppableId !== source.droppableId) {
      toast.info("You can't drop task outside of Stage");
      return;
    }
    const draggedTask = taskData.find((stage) => stage.stageName === source.droppableId).stageTasks.find((curTask) => curTask.taskId === draggableId);
    const updatedData = [...taskData];

    const stageIndex = updatedData.findIndex((stage) => stage.stageName === source.droppableId);

    // const sourceIndex = updatedData.findIndex((stage) => stage.stageName === source.droppableId);
    // const destinationIndex = updatedData.findIndex((stage) => stage.stageName === destination.droppableId);

    updatedData[stageIndex].stageTasks.splice(source.index, 1);
    updatedData[stageIndex].stageTasks.splice(destination.index, 0, draggedTask);
    setTaskData(updatedData);
  };

  return (
    <DragDropContext onDragEnd={(e) => onDragEnd(e)}>
      <div>
        <div className="task_view_tab">
          <div className="pull-right">
            {
              props.accessType == 1 && 
            <button className="btn btn-success-oms" onClick={() => onNewTaskModelOpen()}>
              New Task
            </button>
            }
          </div>
          <br />
          <div className="tasks">
            {taskData?.map((curStage, i) => {
              let minHeightOfCurrentStage = null;
              if (props.accessType == 1) {
                minHeightOfCurrentStage = curStage.stageTasks?.length * 70 + 65;
              } else if (props.accessType == 0) {
                const curUserTasks = curStage.stageTasks?.filter((curTask, i) => {
                  let userIDs = [];
                  curTask.assignedRoles.map((curRole) => {
                    if (curRole.name.length > 0) {
                      curRole.name.map((curU) => {
                        if (curU.value) {
                          userIDs.push(curU.value);
                        }
                      });
                    }
                  });

                  return userIDs.includes(userSession.userId);
                });
                minHeightOfCurrentStage = curUserTasks?.length * 70 + 65;
              }

              return (
                <Droppable key={i} droppableId={curStage.stageName}>
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                      style={{ minHeight: minHeightOfCurrentStage ? `${minHeightOfCurrentStage}px` : "" }}
                    >
                      <div className="d-flex">
                        <h5 style={{ marginTop: 25 }} onClick={() => onStageExpectedModelOpen(curStage, i)}>
                          {curStage.stageName == "No Milestone" && curStage.stageTasks.length == 0 ? (
                            ""
                          ) : (
                            <>
                              <b>{curStage.stageName}</b>
                              {curStage.stageExpected ? " expected " : ""}
                              <b style={{ marginRight: "5px" }}>{curStage.stageExpected ? dateFormater(curStage.stageExpected) : ""}</b>
                              {props.accessType == 1 && curStage.stageName != "No Milestone" && (
                                <i style={{ cursor: "pointer" }} className="fa fa-solid fa-edit"></i>
                              )}
                            </>
                          )}
                        </h5>
                      </div>
                      {curStage.stageTasks?.map((curTask, i) => {
                        let userIDs = [];
                        curTask.assignedRoles.map((curRole) => {
                          if (curRole.name.length > 0) {
                            curRole.name.map((curU) => {
                              if (curU.value) {
                                userIDs.push(curU.value);
                              }
                            });
                          }
                        });
                        if (props.accessType != 1) {
                          if (userIDs.includes(userSession.userId)) {
                            return (
                              <Draggable key={curTask.taskId} draggableId={curTask.taskId} index={i}>
                                {(provided) => (
                                  <div
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    ref={provided.innerRef}
                                    key={i}
                                    className="task mt-1 bgcolor1 p-2 d-flex align-items-center justify-content-between"
                                  >
                                    <div className="d-flex flex-column">
                                      <div className="d-flex align-items-center">
                                        <h5 style={{ cursor: "pointer" }} onClick={() => onTaskITemClick(curStage.stageName, curTask, i)}>
                                          {curTask.taskName}
                                          {curTask.status == 4 ? (
                                            <b>&nbsp; completed on {displayDate()}</b>
                                          ) : curTask.taskDueDate ? (
                                            <b>&nbsp; due on {dateFormater2(curTask.taskDueDate)}</b>
                                          ) : null}
                                        </h5>
                                        {curTask.comments.length > 0 && (
                                          <span className="mx-2 d-flex align-items-center">
                                            <i className="fa fa-solid fa-align-left bg-dark color-white p-icon"></i>
                                            <span className="coment_circle mx-1">{curTask.comments.length}</span>
                                          </span>
                                        )}
                                      </div>
                                      <div>
                                        {curTask.assignedRoles?.map((curRole, i) => {
                                          return (
                                            <span key={i} className={`tag1_sm bgtag${curRole.assignedRole}`} style={{ marginLeft: i !== 0 ? "5px" : "" }}>
                                              {`${curRole.assignedRole}${curRole.name && curRole.name?.length > 0 ? ":" : ""} ${curRole.name?.map((curEle) => {
                                                return " " + curEle.text;
                                              })}`}
                                            </span>
                                          );
                                        })}
                                      </div>
                                    </div>
                                    <div className={`taskdd bg${curTask.status}status d-flex align-items-center`}>
                                      <OMSDropdown
                                        id={"taskDD"}
                                        options={getTaskMIlestoneDD(curTask.status)}
                                        valueField="value"
                                        labelField="text"
                                        value={curTask.status}
                                        onChange={(e) => handleTaskStatusDD(curStage.stageName, curTask.taskId, e.newValue)}
                                        disabled={props.accessType == 1 ? false : true}
                                      />
                                      <div className="mx-3 d-flex align-items-center">
                                        {i == 0 ? (
                                          <i className="fa fa-angle-up arrow_icon mx-2" aria-hidden="true" style={{ color: "gray" }}></i>
                                        ) : (
                                          <i
                                            className="fa fa-angle-up arrow_icon mx-2"
                                            aria-hidden="true"
                                            style={{ color: "black" }}
                                            onClick={() => onTaskArrowUpClick(curStage.stageName, curTask, i)}
                                          ></i>
                                        )}
                                        {curStage.stageTasks.length - 1 == i ? (
                                          <i className="fa fa-angle-down arrow_icon" aria-hidden="true" style={{ color: "gray" }}></i>
                                        ) : (
                                          <i
                                            className="fa fa-angle-down arrow_icon"
                                            aria-hidden="true"
                                            style={{ color: "black" }}
                                            onClick={() => onTaskArrowDownClick(curStage.stageName, curTask, i)}
                                          ></i>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </Draggable>
                            );
                          }
                        } else {
                          return (
                            <Draggable key={curTask.taskId} draggableId={curTask.taskId} index={i}>
                              {(provided) => (
                                <div
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  ref={provided.innerRef}
                                  key={i}
                                  className="task mt-1 bgcolor1 p-2 d-flex align-items-center justify-content-between"
                                >
                                  <div className="d-flex flex-column">
                                    <div className="d-flex align-items-center">
                                      <h5 style={{ cursor: "pointer" }} onClick={() => onTaskITemClick(curStage.stageName, curTask, i)}>
                                        {curTask.taskName}
                                        {curTask.status == 4 ? (
                                          <b>&nbsp; completed on {displayDate()}</b>
                                        ) : curTask.taskDueDate ? (
                                          <b>&nbsp; due on {dateFormater2(curTask.taskDueDate)}</b>
                                        ) : null}
                                      </h5>
                                      {curTask.comments.length > 0 && (
                                        <span className="mx-2 d-flex align-items-center">
                                          <i className="fa fa-solid fa-align-left bg-dark color-white p-icon"></i>
                                          <span className="coment_circle mx-1">{curTask.comments.length}</span>
                                        </span>
                                      )}
                                    </div>
                                    <div>
                                      {curTask.assignedRoles?.map((curRole, i) => {
                                        return (
                                          <span key={i} className={`tag1_sm bgtag${curRole.assignedRole}`} style={{ marginLeft: i !== 0 ? "5px" : "" }}>
                                            {`${curRole.assignedRole}${curRole.name && curRole.name?.length > 0 ? ":" : ""} ${curRole.name?.map((curEle) => {
                                              return " " + curEle.text;
                                            })}`}
                                          </span>
                                        );
                                      })}
                                    </div>
                                  </div>
                                  <div className={`taskdd bg${curTask.status}status d-flex align-items-center`}>
                                    <OMSDropdown
                                      id={"taskDD"}
                                      options={getTaskMIlestoneDD(curTask.status)}
                                      valueField="value"
                                      labelField="text"
                                      value={curTask.status}
                                      onChange={(e) => handleTaskStatusDD(curStage.stageName, curTask.taskId, e.newValue)}
                                      disabled={props.accessType == 1 ? false : true}
                                    />
                                    <div className="mx-3 d-flex align-items-center">
                                      {i == 0 ? (
                                        <i className="fa fa-angle-up arrow_icon mx-2" aria-hidden="true" style={{ color: "gray" }}></i>
                                      ) : (
                                        <i
                                          className="fa fa-angle-up arrow_icon mx-2"
                                          aria-hidden="true"
                                          style={{ color: "black" }}
                                          onClick={() => onTaskArrowUpClick(curStage.stageName, curTask, i)}
                                        ></i>
                                      )}
                                      {curStage.stageTasks.length - 1 == i ? (
                                        <i className="fa fa-angle-down arrow_icon" aria-hidden="true" style={{ color: "gray" }}></i>
                                      ) : (
                                        <i
                                          className="fa fa-angle-down arrow_icon"
                                          aria-hidden="true"
                                          style={{ color: "black" }}
                                          onClick={() => onTaskArrowDownClick(curStage.stageName, curTask, i)}
                                        ></i>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              )}
                            </Draggable>
                          );
                        }
                      })}
                    </div>
                  )}
                </Droppable>
              );
            })}
          </div>
        </div>

        {/* Models */}
        <TaskModel
          modelId="taskviewTaskModel"
          ref={taskModelRef}
          isTaskEdit={isTaskEdit}
          isBreadCrumb={false}
          tasksStageDD={tasksStageDD}
          contacts={props.contacts}
          assignedRolesDD={assignedRolesDD}
          onSave={onTaskSave}
          onEdit={onTaskEditSave}
          syncId={props.syncId}
          accessType={props.accessType}
        />
        <div className="modal fade" id="task_expected_model" tabIndex={-1} role="dialog" aria-labelledby="task_expected_model">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
                <h3 className="modal-title" id="">
                  Update Due Date
                </h3>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <input type="date" className="form-control" value={taskExpected} onChange={(e) => setTaskExpected(e.target.value)} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <div className="col-md-12">
                  <button type="button" className="btn btn-default" data-dismiss="modal">
                    <i className="fa fa-times"></i> Cancel
                  </button>
                  <button className="btn btn-success-oms" onClick={() => onStageExpectedEdit()}>
                    <i className="fa fa-check"></i> Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ConfirmationModalPopup {...confirmationModalProps} />
      </div>
    </DragDropContext>
  );
});

export default DealTaskStepView;
